module.exports = __webpack_public_path__ + "static/paladin-mtg_clb-dd6b6febd2fd0484e82a30120755e0a3.jpg";